import API from 'app/utils/apiClient';

const getContest = (contestId) => API.get(`/story-contests/${contestId}/`);

const postContestComplete = (contestId) =>
  API.post(`/story-contests/${contestId}/event-complete/`, { type: 'JOIN' });

const getContestEvent = (contestId) =>
  API.get(`/story-contests/${contestId}/event/`);

const getContestMyStory = (contestId, storyId) =>
  API.get(`/story-contests/${contestId}/my-stories/${storyId}/`);

const getContestStory = (contestId, storyId) =>
  API.get(`/story-contests/${contestId}/stories/${storyId}/`);

const postContestStoryVote = (contestId, storyId) =>
  API.post(`/story-contests/${contestId}/stories/${storyId}/vote/`);

const getContestRanking = (contestId) =>
  API.get(`/story-contests/${contestId}/ranking/`);

export default {
  getContest,
  postContestComplete,
  getContestEvent,
  getContestMyStory,
  getContestStory,
  postContestStoryVote,
  getContestRanking,
};



// WEBPACK FOOTER //
// ./src/app/apis/contest.js